import { postRequest } from '../../../utils/utils';
import {Toast} from 'antd-mobile';
// ------------------------------------
// Constants
// ------------------------------------
export const JIABAN_CHECK = 'JIABAN_CHECK'

// ------------------------------------
// Actions
// ------------------------------------



export const checkJiaban = (body, history) => {
    return async (dispatch, getState) => {
        postRequest(`/jiaban/save_check`, body).then((value) => {
         // console.log(value);
            if(value.suc === 0) {
                Toast.info(value.msg, 1);
                if(value.msg === '请登陆！') {
                    localStorage.removeItem('daka_token')
                    alert('账号已在别处登录,请重新登录')
                    this.props.history.push('/')
                }
            } else {
                history.push('/jiaban/list');
                Toast.success(value.msg, 1);
            }
        })
    }
}


